import { SpendModeAccountBookItemI } from "../config/SpendInterface";
import spendGameManager from "../manager/spendGameManager";
import spendMode from "../spendMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class investmentPage extends cc.Component {

    @property({type:cc.Label,displayName:"文本"})
    lb_dec:cc.Label = null;

    @property({type:cc.Node,displayName:"按钮layout"})
    btnLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"追投钱的节点"})
    coinNode:cc.Node = null;

    @property({type:cc.Label,displayName:"钱的文本"})
    lb_Money:cc.Label = null;

    @property({type:cc.Node,displayName:"center节点"})
    centerNode:cc.Node = null;

    gameLayer:spendGameManager = null;
    data:SpendModeAccountBookItemI = null;

    canClick:boolean = true;
    clickFun :(isOk:boolean) => void = null;

    start(){
        // this.centerNode.scale = 0;
        // cc.tween(this.centerNode).to(0.5,{scale:1},{easing:cc.easing.backOut}).start();
    }

    bindData(data:SpendModeAccountBookItemI,gameLayer:spendGameManager,clickFun:(isOk:boolean)=>void){
        this.clickFun = clickFun;
        this.data = data;
        this.gameLayer = gameLayer;
        this.updateDialog();
    }

    async updateDialog(){
        let dec:string = this.data.chasingThrowDesc;
        let money:number = this.data.chasingThrowCoins;
        for(let i =0;i<dec.length;i++){
            let s:string = dec[i];
            this.lb_dec.string += s;
            await new Promise<void>(resolve=>{
                this.scheduleOnce(()=>{
                    resolve();
                },.05);
            });
        }
        this.coinNode.active = true;
        this.lb_Money.string = money.toString();
        this.btnLayout.active = true;
    }

    onBtnComit(e:cc.Event.EventTouch){
        if(!this.canClick) return;
        this.canClick = false;
        this.closeThis(()=>{
            this.clickFun && this.clickFun(true);
        });
    }

    onBtnCancel(e:cc.Event.EventTouch){
        if(!this.canClick) return;
        this.canClick = false;
        this.closeThis(()=>{
            this.clickFun && this.clickFun(false);
        });
    }

    closeThis(complete?:()=>void){
        // cc.tween(this.centerNode).to(0.5,{scale:0},{easing:cc.easing.backIn}).start();
        // this.scheduleOnce(()=>{
            complete && complete();
            this.node.destroy();
            this.node.removeFromParent();
        // },.5);
    }

}
